var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareNodesSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.75C16.0703 7.75 17.75 6.07031 17.75 4C17.75 1.92969 16.0703 0.25 14 0.25C11.9297 0.25 10.25 1.92969 10.25 4C10.25 4.15625 10.2578 4.3125 10.2773 4.46484L6.60156 6.30078C5.92969 5.64844 5.01172 5.25 4 5.25C1.92969 5.25 0.25 6.92969 0.25 9C0.25 11.0703 1.92969 12.75 4 12.75C5.01172 12.75 5.92969 12.3516 6.60156 11.6992L10.2773 13.5352C10.2578 13.6875 10.25 13.8398 10.25 14C10.25 16.0703 11.9297 17.75 14 17.75C16.0703 17.75 17.75 16.0703 17.75 14C17.75 11.9297 16.0703 10.25 14 10.25C12.9883 10.25 11.7031 11.2383 11.0312 11.8906L7.72266 10.25C7.72266 11.0352 7.72266 10.25 7.75 9C7.75 8.83984 7.74219 7.90234 7.72266 7.75L11.0312 6.30078C11.7031 6.95312 12.9883 7.75 14 7.75Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareNodesSolid);
export default __webpack_public_path__ + "static/media/share-nodes-solid.50edef4647f68e46aba4908aaa9aed4a.svg";
export { ForwardRef as ReactComponent };